// extracted by mini-css-extract-plugin
export default {"selected":"Navigation_selected__RFpId","activeButton":"Navigation_activeButton__LYVbs","logo":"Navigation_logo__pRALH"};